import { Box, useMediaQuery, useTheme } from '@mui/material';
import React, { ReactElement } from 'react';
import { AddLink } from 'components/ui';
import { AnalyticsDateFilterTrigger } from 'components/pages/admin/analytics/AnalyticsDateFilterTrigger';
import { ExportButton } from 'components/ui';
import type { DateFilterPreset } from 'hooks/useAnalyticsDateFilter';

export interface LeadershipToolbarProps {
  onExport: () => void;
  exportDisabled?: boolean;
  exportLoading?: boolean;
  onAddLeader: () => void;
  dateFilterPreset: DateFilterPreset;
  dateFilterStartDate: Date | null;
  dateFilterEndDate: Date | null;
  onOpenDateFilter: () => void;
}

export function LeadershipToolbar ({
  onExport,
  exportDisabled = false,
  exportLoading = false,
  onAddLeader,
  dateFilterPreset,
  dateFilterStartDate,
  dateFilterEndDate,
  onOpenDateFilter,
}: LeadershipToolbarProps): ReactElement {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <Box
        display="flex"
        flexWrap="wrap"
        gap="16px"
        alignItems="flex-end"
        justifyContent="flex-start"
        sx={{
          width: '100%',
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
        }}
      >
        <Box flexShrink={0}>
          <AnalyticsDateFilterTrigger
            preset={dateFilterPreset}
            startDate={dateFilterStartDate}
            endDate={dateFilterEndDate}
            onClick={onOpenDateFilter}
            sx={{
              width: 56,
              height: 50,
              justifyContent: 'center',
              '& .MuiTypography-root': { display: 'none' },
            }}
          />
        </Box>
        <Box flex={1} minWidth={0} display="flex" alignItems="center" height={50} px="16px" py="10px">
          <AddLink onClick={onAddLeader}>Add Organization Leader</AddLink>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        width: '100%',
        maxWidth: 1400,
        height: 50,
        mb: 0,
      }}
    >
      <Box display="flex" gap="16px" alignItems="center">
        <ExportButton
          onClick={onExport}
          disabled={exportDisabled}
          loading={exportLoading}
          label="Export"
          hideLabelOnMobile={false}
        />
        <AddLink onClick={onAddLeader}>Add Organization Leader</AddLink>
      </Box>
      <AnalyticsDateFilterTrigger
        preset={dateFilterPreset}
        startDate={dateFilterStartDate}
        endDate={dateFilterEndDate}
        onClick={onOpenDateFilter}
        sx={{ width: 250 }}
      />
    </Box>
  );
}
